import { withoutAuth } from '@/components/layout'
import { EmployeeLoginPage } from '@/components/pages/EmployeeLogin'
import { LoginPage } from '@/components/pages/Login'
import { isDenebEnabled } from '@/const/flags'

const Page = isDenebEnabled ? EmployeeLoginPage : LoginPage

export default withoutAuth(Page)
